import { StatusType, displayStatusTypes } from '@hakimo-ui/hakimo/types';
import { Selectable } from '@hakimo-ui/shared/ui-base';

export const highlightTimePeriod = 5000;

export const displayStatusSelectables: Selectable<StatusType>[] =
  displayStatusTypes.map((name, index) => ({
    id: `${index}`,
    name,
  }));

export const NEW_ALARM_TOAST_ID = 'audio-notify-new-alarm';

export const LOCATION_ALARM_QUERY_INTERVAL = 10000;

export const DEFAULT_ALARM_TYPE_COLOR_CLASS = '';
